<template>
  <div class="content-section">
    <h2 class="page-title">客户管理</h2>
    <div class="table-container">
      <el-form :inline="true" :model="queryParams" class="demo-form-inline">
        <el-form-item label="名称">
          <el-input v-model="queryParams.keyWord" placeholder="关键字"></el-input>
        </el-form-item>
        <el-form-item>
          <button class="btn btn-primary" @click.prevent="loadData">查询</button>
        </el-form-item>
      </el-form>
      <el-table
        :data="agentData"
        height="500"
        v-loading="tableLoading"
        border
        style="width: 100%">
        <!--<el-table-column-->
          <!--prop="F_Id"-->
          <!--label="编号"-->
          <!--align="center"-->
          <!--header-align="center"-->
          <!--width="150">-->
        <!--</el-table-column>-->
        <el-table-column
          prop="F_UserName"
          label="帐号"
          align="center"
          header-align="center"
          width="120">
        </el-table-column>
        <el-table-column
          prop="F_Phone"
          label="手机号"
          align="center"
          header-align="center"
          width="120">
        </el-table-column>
        <el-table-column
          prop="F_AgentName_Auth"
          label="认证名称"
          align="center"
          header-align="center"
          width="120">
        </el-table-column>
        <el-table-column
          prop="F_AgentType_Auth"
          align="center"
          header-align="center"
          width="120"
          label="认证类型">
          <template slot-scope="scope">
            <el-tag type="success" v-if="scope.row.F_AgentType_Auth == 1" size="medium">运营中心</el-tag>
            <el-tag type="danger" effect="dark" v-else-if="scope.row.F_AgentType_Auth == 2" size="medium">代理</el-tag>
          </template>
        </el-table-column>
        <!--<el-table-column-->
          <!--prop="F_LinkUserName"-->
          <!--align="center"-->
          <!--header-align="center"-->
          <!--label="联系人">-->
        <!--</el-table-column>-->
        <!--<el-table-column-->
          <!--prop="F_LinkUserPhone"-->
          <!--align="center"-->
          <!--header-align="center"-->
          <!--width="120"-->
          <!--label="联系方式">-->
        <!--</el-table-column>-->
        <!--<el-table-column-->
          <!--prop="F_AuditStatus"-->
          <!--align="center"-->
          <!--header-align="center"-->
          <!--width="120"-->
          <!--label="审核状态">-->
          <!--<template slot-scope="scope">-->
            <!--<el-tag type="info" v-if="scope.row.F_AuditStatus == 0" size="medium">未申报</el-tag>-->
            <!--<el-tag type="primary" v-else-if="scope.row.F_AuditStatus == 1" size="medium">待审核</el-tag>-->
            <!--<el-tag v-else-if="scope.row.F_AuditStatus == 2" size="medium" type="success">审核通过</el-tag>-->
            <!--<el-tag type="danger" v-else-if="scope.row.F_AuditStatus == 3" size="medium">审核驳回</el-tag>-->
          <!--</template>-->
        <!--</el-table-column>-->
        <!--<el-table-column-->
          <!--prop="F_SignStatus"-->
          <!--align="center"-->
          <!--header-align="center"-->
          <!--width="120"-->
          <!--label="签约状态">-->
          <!--<template slot-scope="scope">-->
            <!--<el-tag type="info" v-if="scope.row.F_SignStatus == 0" size="medium">未签约</el-tag>-->
            <!--<el-tag type="primary" v-else-if="scope.row.F_SignStatus == 1" size="medium">签约中</el-tag>-->
            <!--<el-tag v-else-if="scope.row.F_SignStatus == 2" size="medium" type="success">签约通过</el-tag>-->
          <!--</template>-->
        <!--</el-table-column>-->
        <el-table-column
          prop="F_CreateTime"
          align="center"
          header-align="center"
          width="180"
          label="注册时间">
        </el-table-column>
        <el-table-column
          prop="F_AuditStatus"
          align="center"
          header-align="center"
          width="120"
          label="认证状态">
            <template slot-scope="scope">
              <el-tag type="info" v-if="scope.row.F_AuditStatus == 0" size="medium">未申报</el-tag>
              <el-tag type="primary" v-else-if="scope.row.F_AuditStatus == 1" size="medium">待审核</el-tag>
              <el-tag v-else-if="scope.row.F_AuditStatus == 2" size="medium" type="success">审核通过</el-tag>
              <el-tag type="danger" v-else-if="scope.row.F_AuditStatus == 3" size="medium">审核驳回</el-tag>
            </template>
        </el-table-column>
        <el-table-column
          prop="CaseCount"
          align="center"
          header-align="center"
          width="120"
          label="案件总数">
            <template slot-scope="scope">
              <div v-if="scope.row.F_AuditStatus==2">
                {{ scope.row.CaseCount }}
              </div>
            </template>
        </el-table-column>
        <el-table-column
          prop="CaseCountAudited"
          align="center"
          header-align="center"
          width="150"
          label="案件初审通过数">
          <template slot-scope="scope">
              <div v-if="scope.row.F_AuditStatus==2">
                {{ scope.row.CaseCountAudited }}
              </div>
            </template>
        </el-table-column>
        <el-table-column
          prop="CaseCountSigined"
          align="center"
          header-align="center"
          width="120"
          label="案件签约数">
          <template slot-scope="scope">
              <div v-if="scope.row.F_AuditStatus==2">
                {{ scope.row.CaseCountSigined }}
              </div>
            </template>
        </el-table-column>
        <!--<el-table-column-->
          <!--align="center"-->
          <!--header-align="center"-->
          <!--width="80"-->
          <!--fixed="right"-->
          <!--label="操作">-->
          <!--<template slot-scope="scope">-->
            <!--<button class="btn btn-sm btn-primary" @click="onDisplay(scope.row)">查看</button>-->
          <!--</template>-->
        <!--</el-table-column>-->
      </el-table>
      <el-pagination
        background
        layout="prev, pager, next"
        :page-size="PageSize"
        @current-change="onCurrentChange"
        @size-change="onSizeChange"
        :total="total">
      </el-pagination>
    </div>
    <el-dialog v-loading="loadingFull"
               element-loading-text="拼命加载中"
               element-loading-spinner="el-icon-loading"
               element-loading-background="rgba(0, 0, 0, 0.8)" center title="查看" :visible.sync="yyzxVisible" :close-on-click-modal="false">

        <el-form :model="info" label-position="right" label-width="150px">
          <div v-if="info.F_Type == 1" class="info-show">
            <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item label="企业名称：" prop="F_CompanyName">
                  <div class="value-sty">
                    {{info.F_CompanyName}}
                  </div>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="社会统一信用代码：" prop="F_BusinessLicense">
                  <div class="value-sty">
                    {{info.F_BusinessLicense}}
                  </div>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item label="联系地址：" prop="F_Address">
                  <div class="value-sty">
                    {{info.F_Address}}
                  </div>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="法人姓名：" prop="F_JuridicalPersonName">
                  <div class="value-sty">
                    {{info.F_JuridicalPersonName}}
                  </div>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item label="法人身份证号：" prop="F_JuridicalPersonIDNo">
                  <div class="value-sty">
                    {{info.F_JuridicalPersonIDNo}}
                  </div>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="法人手机号：" prop="F_JuridicalPersonTel">
                  <div class="value-sty">
                    {{info.F_JuridicalPersonTel}}
                  </div>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item label="开户银行：" prop="F_AccountBank">
                  <div class="value-sty">
                    {{info.F_AccountBank}}
                  </div>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="开户银行账号：" prop="F_Account">
                  <div class="value-sty">
                    {{info.F_Account}}
                  </div>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item label="授权方式：" prop="F_IsAuthorize">
                  <div class="value-sty">
                    {{info.F_IsAuthorize?'是':'否'}}
                  </div>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item label="营业执照图片：" prop="F_YYZZImg_Url">
                  <img class="display-img" v-if="info.F_YYZZImg_Url" :src="getImgUrl(info.F_YYZZImg_Url)">
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="法人身份证：" prop="F_FRSFZImg_Url">
                  <img class="display-img" v-if="info.F_FRSFZImg_Url" :src="getImgUrl(info.F_FRSFZImg_Url)">
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item label="银行开户许可证：" prop="F_YYKHXKImg_Url">
                  <img class="display-img" v-if="info.F_YYKHXKImg_Url" :src="getImgUrl(info.F_YYKHXKImg_Url)">
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="人脸识别图片：" prop="F_FaceImg_Url">
                  <img class="display-img" :src="getImgUrl(info.F_FaceImg_Url)">
                </el-form-item>
              </el-col>
            </el-row>
            <div v-if="info.F_IsAuthorize">
              <el-row :gutter="20">
                <el-col :span="12">
                  <el-form-item label="授权人姓名：" prop="F_AuthorizeName">
                    <div class="value-sty">
                      {{info.F_AuthorizeName}}
                    </div>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="授权人身份证号：" prop="F_AuthorizeIDNo">
                    <div class="value-sty">
                      {{info.F_AuthorizeIDNo}}
                    </div>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row :gutter="20">
                <el-col :span="12">
                  <el-form-item label="授权人联系电话：" prop="F_AuthorizePhone">
                    <div class="value-sty">
                      {{info.F_AuthorizePhone}}
                    </div>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="授权人联系地址：" prop="F_AuthorizeAddress">
                    <div class="value-sty">
                      {{info.F_AuthorizeAddress}}
                    </div>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row :gutter="20">
                <el-col :span="12">
                  <el-form-item label="授权人身份证：" prop="F_AuthorizeSFZImg_Url">
                    <img class="display-img" v-if="info.F_AuthorizeSFZImg_Url" :src="getImgUrl(info.F_AuthorizeSFZImg_Url)">
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="授权证明：" prop="F_AuthorizeImg_Url">
                    <img class="display-img" v-if="info.F_AuthorizeImg_Url" :src="getImgUrl(info.F_AuthorizeImg_Url)">
                  </el-form-item>
                </el-col>
              </el-row>
            </div>
          </div>
          <div v-else class="info-show">
            <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item label="姓名：" prop="F_Per_Name">
                  <div class="value-sty">
                    {{info.F_Per_Name}}
                  </div>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="身份证号：" prop="F_Per_IDNo">
                  <div class="value-sty">
                    {{info.F_Per_IDNo}}
                  </div>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item label="手机号：" prop="F_Per_Phone">
                  <div class="value-sty">
                    {{info.F_Per_Phone}}
                  </div>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="联系地址：" prop="F_Per_Address">
                  <div class="value-sty">
                    {{info.F_Per_Address}}
                  </div>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item label="开户银行：" prop="F_Per_AccountBank">
                  <div class="value-sty">
                    {{info.F_Per_AccountBank}}
                  </div>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="开户银行账号：" prop="F_Per_Account">
                  <div class="value-sty">
                    {{info.F_Per_Account}}
                  </div>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item label="身份证照片：" prop="F_Per_SFZImg_Url">
                  <img class="display-img" v-if="info.F_Per_SFZImg_Url" :src="getImgUrl(info.F_Per_SFZImg_Url)">
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="人脸识别图片：" prop="F_Per_FaceImg_Url">
                  <img class="display-img" :src="getImgUrl(info.F_Per_FaceImg_Url)">
                </el-form-item>
              </el-col>
            </el-row>
          </div>
        </el-form>

      <div slot="footer" class="dialog-footer">
        <el-button type="info" plain @click="yyzxVisible = false">取 消</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  export default {
    components: {
    },
    data() {
      return {
        info: {
        },
        queryParams:{
          keyWord:''
        },
        url: {
          // list: SZH.assets.api + '/Custom/GetPagingAgents',
          list: SZH.assets.api + '/Custom/GetPagingCustomAccounts',
          GetCustomAgentFormJson: SZH.assets.api + '/Custom/GetCustomAgentFormJson',
        },
        rules: {

        },
        formTemplate: [

        ],
        PageIndex:1,
        PageSize:50,
        total:0,
        agentData:[],
        loadingFull:false,
        yyzxVisible:false,
        tableLoading:false,
      }
    },
    methods: {
      getImgUrl(url){
        if(url){
          return SZH.assets.image +'/' + url
        }else{
          return ''
        }
      },
      onDisplay(row){
        let self = this;
        self.yyzxVisible = true;
        self.loadingFull = true;
        self.$http.post(self.url.GetCustomAgentFormJson,{
          keyValue:row.F_Id,
        })
          .then(result => {
            if (result.state == true) {
              self.info = result.data;
              self.loadingFull = false;
            } else {
              self.info = {};
              self.loadingFull = false;
              self.$message.error(result.message);
            }
          }, () => {
            self.loadingFull = false;
            // 请求失败
            self.$message.error('登录失败，请检查您的网络是否可用。');
          });
      },
      onSizeChange(val) {
        this.PageSize = val;
        this.loadData();
      },
      onCurrentChange(val) {
        this.PageIndex = val;
        this.loadData();
      },
      loadData(){
        let self = this;
        self.tableLoading = true;
        self.$http.post(self.url.list,{
          Data:self.queryParams,
          PageIndex:self.PageIndex,
          PageSize:self.PageSize
        })
          .then(result => {
            if (result.state == true && result.data && result.data.Data && result.data.Data.length>0) {
              self.agentData = result.data.Data;
              self.total = result.data.TotalCount;
            } else {
              self.agentData = [];
              self.total = 0;
              self.$message.error(result.message);
            }
            self.tableLoading = false;
          }, () => {
            self.tableLoading = false;
            // 请求失败
            self.$message.error('登录失败，请检查您的网络是否可用。');
          });
      },
    },
    computed: {},

    mounted() {
      this.loadData()
    }
  }
</script>

<style scoped>
.display-img{
  width: 110px;
  height: 110px;
  border-radius: 5px;
}
</style>



// WEBPACK FOOTER //
// src/views/Me/Agent/Agent.vue